import React from 'react';

import { Type } from '@robinhood/design';

import Button from 'src/components/creditApplication/Button';
import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import { NavigationContext } from 'src/components/creditApplication/NavigationProvider';
import { RadioButton, RadioButtonGroup } from 'src/components/creditApplication/RadioButton';
import { LayoutStyle } from 'src/constants/styles';
import { GoldGradient } from 'src/constants/theme';

type RadioButtonValue = 'STUDENT_STANFORD' | 'STUDENT_OTHER' | 'NON_STUDENT';

const StudentLandingPage = () => {
  const { setCurrentPage } = React.useContext(NavigationContext);
  const [radioButtonValue, setRadioButtonValue] = React.useState<RadioButtonValue | null>(null);

  const onChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setRadioButtonValue(e.target.value as RadioButtonValue);
  }, []);

  const onContinue = React.useCallback(() => {
    switch (radioButtonValue) {
      case 'STUDENT_STANFORD':
        setCurrentPage('STUDENT_VERIFICATION');
        break;
      case 'STUDENT_OTHER':
      case 'NON_STUDENT':
        setCurrentPage('LANDING');
    }
  }, [radioButtonValue, setCurrentPage]);

  return (
    <CreditApplicationPageLayout
      title='Which describes you?'
      subtitle='Let us know your current student status.'
      footer={
        <Button
          label='Continue'
          width='full'
          type='button'
          onClick={onContinue}
          state={radioButtonValue ? 'default' : 'disabled'}
        />
      }
    >
      <div css={[LayoutStyle.mt16, LayoutStyle.w100]}>
        <RadioButtonGroup value={radioButtonValue} onChange={onChange}>
          <div css={[LayoutStyle.flex, LayoutStyle.gap12]}>
            <RadioButton
              value='STUDENT_STANFORD'
              label={
                <>
                  {'Stanford student'}
                  <br />
                  <Type.Text size='S' color={GoldGradient}>
                    {'Free Robinhood Gold while enrolled'}
                  </Type.Text>
                </>
              }
            />
            <RadioButton value='STUDENT_OTHER' label='Student at another college' />
            <RadioButton value='NON_STUDENT' label='Not a student' />
          </div>
        </RadioButtonGroup>
      </div>
    </CreditApplicationPageLayout>
  );
};

export default StudentLandingPage;
